<template>
  <p>Coucou</p>
</template>

<script>
  export default {
    name: 'ABTasty',
    components: {
    },
    mounted() {
    },
    methods: {
    }
  }
</script>

<style lang="less">
  .workplaces {
    display: flex;
    justify-content: center;
    align-items: center;

    @media(max-width: 480px) {
      flex-direction: column;
    }
  }

  .logos {
    margin: 8px 32px;
  }

  .main {
    background: #343a40;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ABTasty.vue